import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TipologieAllegato, FileSize } from '../interfaces/utilities';
import { PropertiesService } from './properties.service';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AttachmentsService {

	constructor(
		private httpClient: HttpClient,
		private propService: PropertiesService
	) { }

	getAttachmentsType(): Observable<TipologieAllegato> {
		return this.httpClient.get<TipologieAllegato>(this.propService.getProp('apiPrefix') + '/api/Public/Servizi/TipologieAllegato');
	}

	getAttachmentsTypeEdition(): Observable<TipologieAllegato> {
		return of<TipologieAllegato>(
			{
				"tipiAllegato": [
					{
						"id": 1,
						"nome": "Logo"
					},
					{
						"id": 2,
						"nome": "PDF"
					},
					{
						"id": 7,
						"nome": "Photo",
						"etichetta": "foto"
					},
					{
						"id": 9,
						"nome": "Other"
					}
				],
				"esito": 0,
				"descrizione": ""
			}
		);
	}

	getAttachmentsTypeRecordCompany(): Observable<TipologieAllegato> {
		return of<TipologieAllegato>(
			{
				"tipiAllegato": [
					{
						"id": 1,
						"nome": "Logo"
					},
					{
						"id": 2,
						"nome": "PDF"
					},
					{
						"id": 3,
						"nome": "Membership form"
					},
					{
						"id": 7,
						"nome": "Photo",
						"etichetta": "foto"
					},
					{
						"id": 9,
						"nome": "Other"
					}
				],
				"esito": 0,
				"descrizione": ""
			}
		)
	}
}
